import type {FC} from "react";
import {memo, useMemo} from "react";

import type {OptionType} from "../Select";
import SelectGeneric from "../SelectGeneric";

type SendToValue = "guestOnly" | "emailEnabled" | "smsEnabled" | "webhookEnabled";

export type SendToOption = OptionType<SendToValue>;

interface Props {
    value: SendToValue;
    onChange: (value: SendToValue) => void;
}

const SelectSendTo: FC<Props> = ({value, onChange}) => {
    const options = useMemo(
        () =>
            [
                {
                    value: "guestOnly",
                    label: "Guest"
                },
                {
                    value: "emailEnabled",
                    label: "Email (Cleaner, Manager, etc.)"
                },
                {
                    value: "smsEnabled",
                    label: "SMS (Cleaner, Manager, etc.)"
                },
                {
                    value: "webhookEnabled",
                    label: "Webhook"
                }
            ] satisfies SendToOption[],
        []
    );

    return (
        <SelectGeneric
            options={options}
            placeholder="Send to..."
            testID="select-send-to"
            value={value}
            onChange={onChange}
        />
    );
};

export default memo(SelectSendTo);
